export const PracticeTypes =
  'webcam_recording screen_recording written_response email_composition email_reply chat ticket_handling audio_recording';
